import styled from 'styled-components';

const StyledInputFile = styled.input`
  display: none;
`;

export { StyledInputFile };
